import { Component, OnInit } from '@angular/core';
import { ApiExportadorArquivosService } from 'src/app/services/api/exportador/api-exportador-arquivos.service';
import { BucketFileContent } from 'src/app/models/api/exportador/supplier-file';
import { ToastService } from 'src/app/ui/toast/toast.service';
import { ToastType } from 'src/app/ui/toast/toast.model';
import { detectFileType, isJson, ParsedTable, parseTable, toPrettyJson } from '../utils/file-content-parser';
import { mensagemDeErro } from '../utils/error-message';

export type AbaPrevia = 'txt' | 'json' | 'tabela';

@Component({
  selector: 'c-supplier-file-preview-modal',
  templateUrl: './supplier-file-preview-modal.component.html',
  styleUrls: ['./supplier-file-preview-modal.component.scss']
})
export class SupplierFilePreviewModalComponent implements OnInit {

  /** Injetados pelo ModalService via contentInitialState */
  readonly path: string;
  readonly fileName: string;
  /** Fecha o modal; atribuido pelo ComponentLoaderService */
  readonly destroy: () => void;

  arquivo: BucketFileContent;
  tipo: string;
  tabela: ParsedTable;
  json: string;
  /** Aba aberta ao carregar; depois quem manda e o proprio c-tab */
  abaInicial: AbaPrevia = 'txt';

  constructor(
    private api: ApiExportadorArquivosService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.api.getFileContent(this.path).subscribe(
      arquivo => this.preparar(arquivo),
      erro => {
        this.toastService.toast(mensagemDeErro(erro, 'previa'), ToastType.error);
        if (this.destroy) { this.destroy(); }
      }
    );
  }

  copiar(aba: AbaPrevia) {
    const texto = this.textoDaAba(aba);
    if (!texto) { return; }

    navigator.clipboard.writeText(texto).then(
      () => this.toastService.toast('conteúdo copiado para a área de transferência.', ToastType.success),
      () => this.toastService.toast('não foi possível copiar o conteúdo.', ToastType.error)
    );
  }

  private preparar(arquivo: BucketFileContent) {
    this.arquivo = arquivo;

    const conteudo = (arquivo && arquivo.content) || '';
    this.tipo = detectFileType(conteudo, this.path);
    this.tabela = parseTable(conteudo);
    this.json = toPrettyJson(conteudo, this.tabela);
    this.abaInicial = this.definirAbaInicial(conteudo);
  }

  /**
   * Json quando o arquivo se declara json e parseia; tabela quando o conteudo
   * tem estrutura de colunas; texto puro no restante.
   */
  private definirAbaInicial(conteudo: string): AbaPrevia {
    if (this.path.endsWith('.json') && isJson(conteudo)) { return 'json'; }
    if (this.tabela && this.tabela.headers.length > 1 && this.tabela.rows.length) { return 'tabela'; }
    return 'txt';
  }

  private textoDaAba(aba: AbaPrevia): string {
    switch (aba) {
      case 'json':
        return this.json;

      case 'tabela':
        return this.tabela
          ? [this.tabela.headers, ...this.tabela.rows].map(linha => linha.join(';')).join('\n')
          : null;

      default:
        return this.arquivo && this.arquivo.content;
    }
  }

}
